import AirPurifiersInsiderLogo from './logo'
import {airPurifiersInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'airpurifiersinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Air Purifiers Insider',
  logo: <AirPurifiersInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/airpurifiersinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-B6R0N1HZ3G',
    camelCaseUrl: 'AirPurifiersInsider.com',
    title: (category: string, count: string) =>
      `Air Purifiers Insider | Top ${count} Pro Insider Choices for ${category}`,
    description: (_category?: string, _count?: string) =>
      `Find the perfect air purifier. Insider reviews of the 10 best models for every room. Breathe clean with our expert recommendations.`,
    styles: airPurifiersInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
